import { actionCompleted } from '@ignitesales/neuro-application/src/actions/question-action-creators';
import AppContainer from '@ignitesales/neuro-application/src/components/AppContainer';
import PageContainer from '@ignitesales/neuro-application/src/components/PageContainer';
import TransitionContainer from '@ignitesales/neuro-application/src/components/TransitionContainer';
import React, {useMemo, useState} from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from './AppContext';
import Header from './components/Header';
import ErrorBoundary from './components/pages/ErrorBoundary';
import LandingPage from './components/pages/LandingPage';
import SummaryPage from './components/pages/SummaryPage';
import SurveyPage from './components/pages/SurveyPage';
import Sidebar from './components/Sidebar';
import { QueryParamProvider } from 'use-query-params';
import AnswersList from './components/AnswersList';
import ProductCart from './components/ProductCart';
import {Resources} from '@ignitesales/diana-components'
import { flatProductList } from '@ignitesales/neuro-application/src/util/productUtil';



const calcIsHelpingHands = (products) => {
  return (products?.groups?.[0]?.name || '').startsWith('helpingHands');
};

const App = ({location, page, products, onActionCompleted, processingNavigation, progress,  user, isBranchGuide, answers}) => {
  const isHelpingHands = useMemo(() => calcIsHelpingHands(products), [
    products
  ]);

  const [ showCart, setShowCart ] = useState(true);

  const ResolvedSummaryPage = isHelpingHands 
    ? 
      (state) => {
        const answersWithPageInfo = state.answersWithPageInfo || {};

        return (
          <Resources key="resources" AnswersList={AnswersList} products={products} answers={answers} answersWithPageInfo={answersWithPageInfo} user={user}>
            <ProductCart
              answers={ answers }
              isOpen={ showCart }
              onClose={ () => setShowCart(false) }
              onRemoveFromCart={ () => undefined }
              productApplyClicked={ () => undefined }
              selectedProducts={ flatProductList(products) }
            />
          </Resources>
        )
      }
    
    : SummaryPage;

  return (
    <AppProvider value={{isHelpingHands}}>
      <QueryParamProvider>
        <AppContainer ErrorBoundary={ErrorBoundary} location={location}>
          <Header
            isBranchGuide={isBranchGuide}
            user={user}
            page={page}
            onActionCompleted={onActionCompleted}
            processingNavigation={processingNavigation}
          />
          <Route
            render={(props) => (
              <PageContainer
                {...props}
                LandingPage={LandingPage}
                SurveyPage={SurveyPage}
                SummaryPage={ResolvedSummaryPage}
                DetailsPage={SummaryPage}
                render={({ route }) => {
                  return (
                    <TransitionContainer
                      className="pageContainer"
                      transitionKey={location.key}
                    >
                      {route}
                    </TransitionContainer>
                  );
                }}
              />
            )}
          />
          <Sidebar currentPage={page} progress={progress} />
          <ToastContainer />
        </AppContainer>
      </QueryParamProvider>
    </AppProvider>
  );
};

export default connect((state,{location}) => {
  const {
    progress: {total = 0} = {},
    user,
    isBranchGuide
  } = state;
  const page = state.pages[location.pathname] || {};
  const processingNavigation = state.processingNavigation || false;
  const products = state.products || {};
  const answers = state.answers || {};

  return {
    answers,
    location,
    page,
    processingNavigation,
    progress: total,
    products,
    user,
    isBranchGuide
  };
}, dispatch => {
  return {
    onActionCompleted: (actionName) => {
      dispatch(actionCompleted({ actionName }))
    }
  }
})(App);
